(function(){
  var catalogPromise = null;

  function normalizeSku(value) {
    return String(value || '').trim().toUpperCase();
  }

  function escHtml(text) {
    return String(text || '').replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }

  async function fetchCatalogPages(){
    var map = new Map();
    var seenProductIds = new Set();
    var pageSize = 250;

    for (var page = 1; page <= 20; page++) {
      var response = await fetch('/collections/t100-parts/products.json?limit=' + pageSize + '&page=' + page, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Catalog response ' + response.status);

      var data = await response.json();
      var products = data.products || [];
      var addedProducts = 0;

      products.forEach(function(product){
        var productKey = String(product.id || product.handle || '');
        if (productKey && seenProductIds.has(productKey)) return;
        if (productKey) seenProductIds.add(productKey);
        addedProducts++;

        (product.variants || []).forEach(function(variant){
          var sku = normalizeSku(variant.sku);
          if (!sku) return;
          var numericPrice = Number(variant.price || 0);
          map.set(sku, {
            handle: product.handle,
            title: product.title,
            url: '/products/' + product.handle,
            price: Number.isFinite(numericPrice) ? numericPrice : null,
            available: !!variant.available
          });
        });
      });

      if (products.length < pageSize || addedProducts === 0) break;
    }

    return map;
  }

  async function loadLiveCatalog(){
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetchCatalogPages().catch(function(){
      return new Map();
    });
    return catalogPromise;
  }

  async function enhanceRows(){
    var table = document.getElementById('tjaPartsTable');
    if (!table) return;
    var map = await loadLiveCatalog();
    table.querySelectorAll('tbody tr').forEach(function(row){
      var cells = row.querySelectorAll('td');
      if (cells.length < 4) return;
      var sku = normalizeSku(cells[2].textContent);
      var cell = cells[3];

      if (!cell.querySelector('.tjaPartRowLookup')) {
        var lookup = document.createElement('a');
        lookup.className = 'tjaPartRowLookup';
        lookup.href = '#t100-visual-lookup';
        lookup.textContent = 'Open diagram';
        lookup.addEventListener('click',function(){
          setTimeout(function(){
            var search = document.getElementById('tjaPartsSearch');
            if (!search) return;
            search.value = sku;
            search.dispatchEvent(new Event('input',{bubbles:true}));
            search.focus();
          },0);
        });
        cell.appendChild(document.createTextNode(' '));
        cell.appendChild(lookup);
      }

      var live = map.get(sku);
      if (live && live.handle && !cell.querySelector('.tjaPartRowProduct')) {
        var product = document.createElement('a');
        product.className = 'tjaPartRowProduct';
        product.href = live.url;
        product.textContent = 'View / Buy';
        cell.appendChild(document.createTextNode(' '));
        cell.appendChild(product);
      }
    });
  }

  function decorateMeta(root){
    if (!root) return;
    root.querySelectorAll('.tjaPartsRowMeta').forEach(function(meta){
      if (meta.querySelector('.tjaPartsNeedHelp')) return;
      var a = document.createElement('a');
      a.className = 'tjaPartsNeedHelp';
      a.href = '/pages/contact';
      a.textContent = 'Need help identifying this part?';
      meta.appendChild(document.createTextNode(' · '));
      meta.appendChild(a);
    });
  }

  function watchDynamicResults(){
    var root = document.getElementById('tjaPartsResults');
    if (!root) return;
    decorateMeta(root);
    var observer = new MutationObserver(function(){
      decorateMeta(root);
    });
    observer.observe(root,{childList:true,subtree:true});
  }

  function boot(){
    enhanceRows();
    watchDynamicResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',boot);
  } else {
    boot();
  }
})();
